import { render, staticRenderFns } from "./ShopFormModal.vue?vue&type=template&id=6faf1f94&scoped=true"
import script from "./ShopFormModal.vue?vue&type=script&lang=js"
export * from "./ShopFormModal.vue?vue&type=script&lang=js"
import style0 from "./ShopFormModal.vue?vue&type=style&index=0&id=6faf1f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faf1f94",
  null
  
)

export default component.exports